import { api } from "@/services/api"
import { useMutation } from "@tanstack/react-query"

interface CreateStudySessionParams {
  id: string
  activityId: string
}

export default function useCreateStudySession() {
  return useMutation({
    mutationKey: ["create-study-session"],
    mutationFn: (payload: CreateStudySessionParams) =>
      api.odin.activities.lessons.createStudySession(payload).then((resp) => resp.data.description),
  })
}
